import { type FC } from "react";
import Link from "next/link";
import { Typography } from "@/components/essentials/typography";
import { Box } from "@chakra-ui/layout";
import { Button } from "@/components/essentials/button";
import { pagesPath } from "@/pathpida/generated/$path";

export const SignupNavigation: FC = () => {
  return (
    <Box my="2.5rem" w="100%" textAlign="center">
      <Typography variant="text2" mb="1rem" color="gray.dark">
        マイページ登録されていない方はこちら
      </Typography>
      <Button as={Link} href={pagesPath.signup.$url()} w="100%" size="lg" styleVariant="mono">
        マイページに新規登録
      </Button>
    </Box>
  );
};
